import {
  FaCalendarCheck,
  FaCalendarDay,
  FaGears,
  FaHouse,
  FaPlaneDeparture,
} from "react-icons/fa6";

const MenuAdminAppo = [
  {
    label: "Home",
    to: "",
    icon: <FaHouse />,
  },
  {
    label: "Transaction",
    type: "menu-title",
  },
  {
    label: "Appointment",
    to: "transaction/appointment",
    icon: <FaCalendarCheck />,
  },
  {
    label: "Follow up Appointment",
    to: "transaction/follow-up-appointment",
    icon: <FaCalendarDay />,
  },
  {
    label: "Vacation",
    to: "employee/vacation",
    icon: <FaPlaneDeparture />,
  },
  {
    label: "Setting",
    type: "menu-title",
  },
  // {
  //   label: "Setting",
  //   icon: <FaGears />,
  //   to: "setting/general",
  //   children: [],
  // },
];

export default MenuAdminAppo;
